import types from '../actions/types';
import {
    paginatedResultReducer
} from './common/paginated_results';
import {
    removeItem
} from './common/remove-item';
import {multipleResultReducer} from './common/multiple-results';
import { singleResultReducer } from './common/single-result';

const initial_state = {
    participant: {
        payment: {}
    },
    loading: false
}

export default function (state = initial_state, action) {
    switch (action.type) {
        case types.INITIALIZE_PARTICIPANT_FORM_DATA:
            return {
                ...state,
                participant: action.payload
            };
        case types.LOAD_PARTICIPANT.REQUEST:
        case types.LOAD_PARTICIPANT_BY_UUID.REQUEST:
            return {
                ...state,
                participant: initial_state.participant,
                loading: true
            };
        case types.LOAD_PARTICIPANT.FAILURE:
        case types.LOAD_PARTICIPANT_BY_UUID.FAILURE:
            return {
                ...state,
                participant: initial_state.participant,
                loading: false
            };
        case types.LOAD_PARTICIPANT.SUCCESS:
        case types.LOAD_PARTICIPANT_BY_UUID.SUCCESS:
            return {
                ...state,
                participant: action.payload,
                loading: false
            };
        case types.SUBMIT_PARTICIPANT.SUCCESS:
            return {
                ...state,
                participant: action.payload
            };

        case types.DELETE_PARTICIPANT.SUCCESS:

            return {
                ...state,
                participants: {
                    ...state.participants,
                    items: removeItem(state.participants.items, action.payload.id)
                }

            }

        default:
            return {
                ...state,
                participantV2: singleResultReducer(state.post, types.LOAD_PARTICIPANT_RESULT_V2, action),
                participants: paginatedResultReducer(state.participants, types.LOAD_PARTICIPANTS_PAGINATED, action),
                participant_results: multipleResultReducer(state.participant_results, types.SUBMIT_PARTICIPANT_RESULT_SEARCH, action)
            };

    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/participant.js